module.exports = __webpack_public_path__ + "img/score_simle.28112ae1.png";